import { useSelector } from "react-redux";
import { ScanCode } from "../scan-code";
import {
  StyledMobileQRCodeButton,
  StyledQRCodeContainer,
  StyledQRCodeIcon,
} from "./styles";
import { Modal } from "@/components/uielements/modal";
import { K_ANALYTICS_EVENTS } from "@/constants/events";
import { meSliceSelector } from "@/redux/me/reducer";
import { fireKAnalyticsEvent } from "@/utils/koalaAnalytics";

export const MobileQRCode = () => {
  const { data: me } = useSelector(meSliceSelector);

  if (!me?.qrcode) {
    return null;
  }

  return (
    <>
      <StyledQRCodeContainer>
        <Modal.Container
          trigger={(open) => (
            <StyledMobileQRCodeButton
              aria-label="Click to view your membership ID"
              onClick={() => {
                open();
                fireKAnalyticsEvent(K_ANALYTICS_EVENTS.QR_MEMBERSHIP_VIEW, {
                  name: "Mobile Scan Button",
                });
              }}
            >
              <StyledQRCodeIcon>
                <img
                  src="/static/img/icons/qr.svg"
                  alt="Scan QR Code Icon"
                  role="presentation"
                />
              </StyledQRCodeIcon>
              <p>Scan</p>
            </StyledMobileQRCodeButton>
          )}
        >
          {() => (
            <ScanCode memberCode={me.qrcode} memberId={me?.external_user_fk} />
          )}
        </Modal.Container>
      </StyledQRCodeContainer>
    </>
  );
};
